var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "47px",
    viewBox: "0 0 38 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Doc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.671270461
  }, /*#__PURE__*/React.createElement("g", {
    id: "Individual-Entry-Media-Field/Desktop",
    transform: "translate(-1137.000000, -1161.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Doc",
    transform: "translate(1137.000000, 1161.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5582438,5.66407075 L22.5582438,12.9253384 L31.1332533,12.9253384 L22.5582438,5.66407075 Z M34.4363339,16.4502256 L18.9945887,16.4502256 L18.9945887,3.5248872 L7.18549102,3.5248872 C5.21880955,3.5248872 3.62405964,5.1000888 3.62183592,7.04537535 L3.56392562,39.9435706 C3.56170081,41.8910567 5.15423042,43.4706573 7.12091189,43.4750564 L30.8725306,43.4750564 C32.8414358,43.4750564 34.4363339,41.8954557 34.4363339,39.9501692 L34.4363339,16.4502256 Z M21.3488819,0 L37.999989,14.0995488 L37.999989,39.9502256 C37.999989,43.8429982 34.8104892,47 30.8726788,47 L7.12733217,47 C3.17834617,46.9933907 -0.00682024722,43.829801 1.09676221e-05,39.937254 L0.0579299405,7.03905875 C0.0646119363,3.15068518 3.25410093,0.000563981953 7.18524014,0.000563981953 L21.3488819,0 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPlay);
export default __webpack_public_path__ + "static/media/DocPlay.822745ec319f69f9126361371e530256.svg";
export { ForwardRef as ReactComponent };